import * as amplitude from '@amplitude/analytics-browser'

export const init = () => {
  amplitude.init(process.env.REACT_APP_AMPLITUDE_API_KEY, null, {
    serverUrl: process.env.REACT_APP_AMPLITUDE_PROXY_URL,
    defaultTracking: true,
  })
}

export const setUserId = (userId) => amplitude.setUserId(userId)

export const sendEvent = (event, eventProperties, callback) => amplitude.track(event, eventProperties, callback)

export const setUserProperties = (userProperties) => {
  const identifyObj = new amplitude.Identify()
  Object.keys(userProperties).forEach((key) => {
    identifyObj.set(key, userProperties[key])
  })
  return amplitude.identify(identifyObj)
}

export default {
  init,
  sendEvent,
  setUserId,
  setUserProperties,
}
